import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BulkUploadFile from "../../BulkUploadFile";
import * as FeatureToggleActions from "../../../store/actions/FeatureToggle";
import styled from "styled-components";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Max upload limit is 1000.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <FeatureToggleBulkDeleteUpload>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="featureToggleBulkDeleteUploadModal"
        uploadUrl="/feature/toggle/bulk-delete/ack"
        sampleURL="/sample/bulk_delete_feature_toggle_by_entity_ids.csv"
        id="featureToggleBulkDeleteUploadModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Delete Feature Toggle"
        getUploadUrl={getUploadUrl}
      ></BulkUploadFile>
    </FeatureToggleBulkDeleteUpload>
  );
};

const FeatureToggleBulkDeleteUpload = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      FeatureToggleActions.getBulkDeleteUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
